import { useUser } from "@clerk/react-router";
import { useEffect, useRef } from "react";

declare global {
  interface Window {
    $crisp?: unknown[];
    CRISP_WEBSITE_ID?: string;
    Crisp?: {
      user?: {
        setNickname?: (name: string) => void;
        setEmail?: (email: string) => void;
      };
    };
  }
}

export function CrispChat() {
  const { user, isLoaded: userLoaded } = useUser();
  const scriptLoadedRef = useRef(false);
  const userSetRef = useRef(false);

  useEffect(() => {
    // Only load script once on the client side
    if (scriptLoadedRef.current || typeof window === "undefined") return;

    const websiteId = import.meta.env.VITE_CRISP_WEBSITE_ID;
    if (!websiteId) {
      console.warn("VITE_CRISP_WEBSITE_ID is not set");
      return;
    }

    // Check if script already exists
    const existingScript = document.querySelector(
      'script[src="https://client.crisp.chat/l.js"]'
    );

    if (!existingScript) {
      // Initialize Crisp globals
      window.$crisp = [];
      window.CRISP_WEBSITE_ID = websiteId;

      // Inject Crisp script
      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.async = true;
      document.head.appendChild(script);
    }

    scriptLoadedRef.current = true;
  }, []);

  useEffect(() => {
    // Set user info only once when user is loaded
    if (
      !userLoaded ||
      !user ||
      userSetRef.current ||
      typeof window === "undefined"
    ) {
      return;
    }

    // Wait for Crisp to be available
    const setUserInfo = () => {
      if (window.Crisp?.user) {
        // Set user information
        if (user.fullName || user.firstName) {
          window.Crisp.user.setNickname?.(
            user.fullName || user.firstName || "User"
          );
        }

        if (user.primaryEmailAddress?.emailAddress) {
          window.Crisp.user.setEmail?.(user.primaryEmailAddress.emailAddress);
        }

        userSetRef.current = true;
      } else {
        // Crisp not ready yet, try again in a bit
        setTimeout(setUserInfo, 100);
      }
    };

    setUserInfo();
  }, [user, userLoaded]);

  return null;
}
